(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-coming-soon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (seccion.dataset.pcsInit) return;
      seccion.dataset.pcsInit = 'true';
      var contenedor = seccion.querySelector('[data-pcs-cuenta]');
      var elDias = seccion.querySelector('[data-pcs-dias]');
      var elHoras = seccion.querySelector('[data-pcs-horas]');
      var elMinutos = seccion.querySelector('[data-pcs-minutos]');
      var elSegundos = seccion.querySelector('[data-pcs-segundos]');
      var targetStr = seccion.getAttribute('data-pcs-target');
      if (!contenedor || !targetStr) return;
      var target = new Date(targetStr);
      if (isNaN(target.getTime())) return;
      function pad(n) {
        n = Math.floor(n);
        return n < 10 ? '0' + n : '' + n;
      }
      function actualizar() {
        var ahora = new Date();
        var diff = target.getTime() - ahora.getTime();
        if (diff <= 0) {
          if (elDias) elDias.textContent = '00';
          if (elHoras) elHoras.textContent = '00';
          if (elMinutos) elMinutos.textContent = '00';
          if (elSegundos) elSegundos.textContent = '00';
          return;
        }
        var segs = Math.floor(diff / 1000);
        var dias = Math.floor(segs / 86400);
        var horas = Math.floor((segs % 86400) / 3600);
        var minutos = Math.floor((segs % 3600) / 60);
        var segundos = segs % 60;
        if (elDias) elDias.textContent = pad(dias);
        if (elHoras) elHoras.textContent = pad(horas);
        if (elMinutos) elMinutos.textContent = pad(minutos);
        if (elSegundos) elSegundos.textContent = pad(segundos);
      }
      actualizar();
      setInterval(actualizar, 1000);
    }
    function init() {
      document.querySelectorAll('.pcs-seccion').forEach(inicializar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-becay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializar(seccion) {
      if (seccion.dataset.mpbInit) return;
      seccion.dataset.mpbInit = 'true';
      var form = seccion.querySelector('[data-mpb-form]');
      var variantInput = seccion.querySelector('[data-mpb-variant-id]');
      var tallaBtns = seccion.querySelectorAll('[data-mpb-talla]');
      var addBtn = seccion.querySelector('[data-mpb-add]');
      var addText = seccion.querySelector('[data-mpb-add-text]');
      var acordeon = seccion.querySelector('[data-mpb-acordeon-toggle]');
      tallaBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.getAttribute('aria-disabled') === 'true') return;
          var variantId = btn.dataset.mpbVariant;
          if (variantInput) variantInput.value = variantId;
          tallaBtns.forEach(function (b) {
            b.classList.toggle('mpb-talla--activa', b === btn);
          });
          try {
            var url = new URL(window.location);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);
          } catch (err) {}
        });
      });
      if (acordeon) {
        var contenido = seccion.querySelector('[data-mpb-acordeon-contenido]');
        if (contenido) {
          acordeon.addEventListener('click', function () {
            var abierto = acordeon.getAttribute('aria-expanded') === 'true';
            acordeon.setAttribute('aria-expanded', abierto ? 'false' : 'true');
            contenido.style.maxHeight = abierto ? '0' : contenido.scrollHeight + 'px';
          });
        }
      }
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var formData = new FormData(form);
          var textoOriginal = addText ? addText.textContent : '';
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = 'AÑADIENDO...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          })
            .then(function (r) { if (!r.ok) throw new Error('Error'); return r.json(); })
            .then(function () {
              if (addText) addText.textContent = '✓ AÑADIDO';
              document.dispatchEvent(new CustomEvent('cart:updated'));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(function () {
                if (addBtn) addBtn.disabled = false;
                if (addText) addText.textContent = textoOriginal;
              }, 1500);
            })
            .catch(function () {
              if (addText) addText.textContent = 'ERROR';
              setTimeout(function () {
                if (addBtn) addBtn.disabled = false;
                if (addText) addText.textContent = textoOriginal;
              }, 1500);
            });
        });
      }
    }
    function init() {
      document.querySelectorAll('.mpb-seccion').forEach(inicializar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
